import { navigate } from 'gatsby'

const BASE_PATH = '/availability'
const ES_OOA_PATH = '/es/shop-test'
const OOA_PATH = `${BASE_PATH}/out-of-area`

/** Validates city page based on location, otherwise redirects to out of area page */
const availabilitySubmit = async ({ location, setIsSubmitted }) => {
  const isEs = /^\/es(\/|$)/.test(window.location.pathname)
  if (isEs) {
    setIsSubmitted(true)
    navigate(ES_OOA_PATH)
    return
  }

  const state = location?.state?.abbreviation?.toLowerCase()
  const city = location?.city?.toLowerCase()?.split(' ')?.join('-')
  const path = `${BASE_PATH}/${state}/${city}`
  const origin = window.location.origin || ''

  let validPath = false
  if (origin && state && city) {
    const res = await fetch(`${origin}${path}`, { method: 'HEAD' })
    validPath = res.ok
  }

  setIsSubmitted(true)
  navigate(validPath ? path : OOA_PATH)
}

export default availabilitySubmit
